export const ViewMode = {
  expandAll: 'EXPAND',
  collapseAll: 'COLLAPSE',
  selectAll: 'SELECT',
  deSelectAll: 'DESELECT',
};
